import {useEffect, useState} from "react";
import {mrbgStore} from "./mrbg/mrbgRedux";
import {useLocation} from "react-router-dom";
import MilanLogo from "./MilanLogo.jsx";

function Menu({mainStyle}){

  const
    [menuLinks]= useState( mrbgStore.getState().mrbgVars.menuLinks ),
    [device,setDevice] = useState( mrbgStore.getState().device ),
    [prlCls,setPrlCls] = useState(` ${mainStyle.PRL_menu}`),
    [activeMobileMenu,setActiveMobileMenu] = useState( '' ),
    [activeSubMenu,setActiveSubMenu] = useState( [] ),
    currentPath = useLocation().pathname;

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setDevice(mrbgStore.getState().device)
    })
    setPrlCls('')
    return () =>unsubscribe();
  },[])

  if( !menuLinks?.length )
    return '';

  return(
    <>
      {device=='mob'? <i id={mainStyle.menuBtn} className="fa-solid fa-bars" onClick={()=>setActiveMobileMenu(` ${mainStyle.actMobMenu}`)}></i>: ''}
      <section id={mainStyle.menu} className={`${mainStyle.flexRowDesk}${device=='mob'? activeMobileMenu: prlCls}`}>
        <MenuUl {...{menuLinks,device,ulClass:0,currentPath,setActiveMobileMenu,activeSubMenu,setActiveSubMenu,mainStyle}}/>
        <ul id={mainStyle.logoLogin}>
          <li id={mainStyle.B_login}>
            <div id={mainStyle.B_loginBtn}>ثبت نام</div>
            <div id={mainStyle.B_loginForm}>
              <form>
                <div>ورود به داشبورد</div>
                <fieldset>
                  <legend>کد ملی:</legend>
                  <input type="text" name="userName"/>
                </fieldset>
                <fieldset>
                  <legend>گذرواژه:</legend>
                  <input type="password" name="password"/>
                </fieldset>
                <fieldset>
                  <button>ورود</button>
                </fieldset>
                <div id="msg"></div>
              </form>
            </div>
          </li>
          <li>
            <MilanLogo />
          </li>
        </ul>
      </section>
    </>
  )
}

function MenuUl( {menuLinks,device,ulClass,currentPath,parentID,setActiveMobileMenu,activeSubMenu,setActiveSubMenu,mainStyle} ){

  return (
    <ul className={`${mainStyle[`L${ulClass}`]}${parentID && activeSubMenu.includes(parentID)? ` ${mainStyle.actSubMenu}`: ''}`}>
      {
        device == 'mob' &&
        <li>
          <i className="fa-regular fa-angle-double-right" onClick={() => {
            if( ulClass == 0 )
              setActiveMobileMenu('');
            else{
              var x = [...activeSubMenu];
              x.pop();
              setActiveSubMenu(x)
            }
          }}></i>
        </li>
      }
      {
        menuLinks.map(( links, i ) => {
          return (
            <li key={i}>
              <a href={links.path} className={ulClass == 0 && links.path == currentPath? mainStyle.activeLink: ''}>{links.label}</a>
              {( device == 'mob' || ulClass>0 ) && links.subLinks? <i className="fa-regular fa-angle-double-left" onClick={() => setActiveSubMenu([...activeSubMenu, links.id])}></i>: ''}
              {links.subLinks && <MenuUl {...{menuLinks:links.subLinks,device,ulClass:ulClass+1,parentID: links.id,activeSubMenu,setActiveSubMenu,mainStyle}}/>}
            </li>
          )
        })
      }
    </ul>
  )
}

export default Menu;